import { Eye } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { ActionFailure } from '@/components/common/ActionFailure';
import { useAuth } from '@/hooks/useAuth';
import { useEndViewAs } from '@/hooks/useEndViewAs';
import { UI_STRINGS } from '@/lib/constants/ui-strings';
import { formatDateTime } from '@/lib/utils/date.utils';

const T = UI_STRINGS.VIEW_AS;

/**
 * The persistent "you are viewing as" bar in a view-as tab (MYN-335, FR-241):
 * names the user, says it is view only, and offers Exit. Renders nothing in
 * an ordinary session.
 */
export function ViewAsBanner() {
  const { user } = useAuth();
  const end = useEndViewAs();
  if (!user?.viewAs) return null;

  return (
    <div
      role="region"
      aria-label={T.BANNER(user.email)}
      className="bg-warning text-on-yellow flex flex-wrap items-center gap-x-4 gap-y-2 px-6 py-3 text-sm"
    >
      <Eye size={18} aria-hidden className="shrink-0" />
      <div className="flex min-w-0 flex-1 flex-col">
        <span className="font-medium">{T.BANNER(user.email)}</span>
        <span className="text-on-yellow-muted">
          {T.BANNER_BY(user.viewAs.adminName, formatDateTime(user.viewAs.expiresAt))}
        </span>
        <ActionFailure error={end.error} fallback={T.EXIT_FAILED_FALLBACK} />
      </div>
      <Button variant="outline" onClick={() => end.mutate()} disabled={end.isPending}>
        {end.isPending ? T.EXITING : T.EXIT}
      </Button>
    </div>
  );
}
